// Root router for the app.

import type { FunctionComponent } from 'react';

import { splitComponent } from '@dr.pogodin/react-utils';

import { useGlobalState } from 'utils';

const AdminAppRoutes = splitComponent({
  chunkName: 'admin-app',
  getComponent: async () => import(/* webpackChunkName: 'admin-app' */ './Admin'),
});

const AiAppRoutes = splitComponent({
  chunkName: 'ai-app',
  getComponent: async () => import(/* webpackChunkName: 'ai-app' */ './AIApp'),
});

const WebsiteRoutes = splitComponent({
  chunkName: 'website',
  getComponent: async () => import(/* webpackChunkName: 'website' */ './Website'),
});

const AllRoutes: FunctionComponent = () => {
  const [webapp] = useGlobalState('webApp');

  switch (webapp) {
    case 'Admin': return <AdminAppRoutes />;
    case 'Primary': return <AiAppRoutes />;
    case 'Website': return <WebsiteRoutes />;
    default: throw Error('Unexpected case');
  }
};

export default AllRoutes;
